import type {  IOverlayConfig, IOverlayState } from "@/types/ComponentLibrary/component-library";
import { defineStore } from "pinia";

export const overlayStateStore = (identifier: string) =>
  defineStore(`overlay/${identifier}`, {
    state: () => ({
      state: {} as IOverlayState,
      config: {} as IOverlayConfig,
      reload: true
    }),
  })(); 
